<h2 mat-dialog-title>Masowe płatności</h2>

<mat-dialog-content>
	<form [formGroup]="form">
		<mat-card class="mb-3">
			<mat-card-header>
				<mat-card-title>Dane wspólne</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row g-3">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
							<mat-label>Konto oskara</mat-label>
							<input
								type="text"
								matInput
								formControlName="bankAccountPosting"
								[matAutocomplete]="bankAccountAuto"
								required
							/>
							@if (
								(form.controls.bankAccountPosting.touched || submitted) &&
								form.controls.bankAccountPosting.errors?.required
							) {
								<mat-error>Uzupełnij konto</mat-error>
							}
							<mat-autocomplete
								#bankAccountAuto="matAutocomplete"
								[displayWith]="displayFn.bind(this)"
								(optionSelected)="selectOption($event)"
							>
								@for (item of filteredBankAccountPosting; track item.id) {
									<mat-option [value]="item.id">
										{{ getBankAccountOptionLabel(item) }}
									</mat-option>
								}
							</mat-autocomplete>
						</mat-form-field>
					</div>
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
							<mat-label>Data księgowania</mat-label>
							<input matInput required formControlName="posting" [matDatepicker]="postingPicker" />
							@if (
								(form.controls.posting.touched || submitted) && form.controls.posting.errors?.required
							) {
								<mat-error>Uzupełnij datę księgowania</mat-error>
							}
							<mat-datepicker-toggle matSuffix [for]="postingPicker"></mat-datepicker-toggle>
							<mat-datepicker #postingPicker></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
			</mat-card-content>
		</mat-card>

		<h3 class="payments-toolbar__title mb-2">Pozycje płatności</h3>

		<ng-container formArrayName="payments">
			<mat-table #dataTable [dataSource]="payments.controls" class="mat-elevation-z2 payments-table">
				<ng-container matColumnDef="tableId">
					<mat-header-cell *matHeaderCellDef>Numer rezerwacji</mat-header-cell>
					<mat-cell *matCellDef="let element">BAG {{ element.value.tableId }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="userData">
					<mat-header-cell *matHeaderCellDef>Kto wpłaca</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ getUserLabel(element.value.userData) }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="amount">
					<mat-header-cell *matHeaderCellDef>Kwota</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.value.amount }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="payment">
					<mat-header-cell *matHeaderCellDef>Data wpłaty</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.value.payment | date: 'yyyy-MM-dd' }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="bankAccountIncoming">
					<mat-header-cell *matHeaderCellDef>Konto klienta</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.value.bankAccountIncoming }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="invoiceNumber">
					<mat-header-cell *matHeaderCellDef>Nr faktury</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.value.invoiceNumber }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="note">
					<mat-header-cell *matHeaderCellDef>Uwagi</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.value.note }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="actions">
					<mat-header-cell *matHeaderCellDef></mat-header-cell>
					<mat-cell *matCellDef="let element; let i = index" class="actions-cell">
						<button type="button" mat-raised-button (click)="editPos(i)">Edytuj</button>
						<button type="button" mat-raised-button color="warn" (click)="removeRow(i)">Usuń</button>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="showColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: showColumns"></mat-row>
			</mat-table>
		</ng-container>

		@if (!payments.length) {
			<div class="empty-state">Brak pozycji. Kliknij „Dodaj pozycję”, aby dodać pierwszą płatność.</div>
		}
	</form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
	<button type="button" mat-raised-button (click)="addPos()">Dodaj pozycję</button>
	<div class="dialog-actions__spacer"></div>
	<button type="button" mat-raised-button (click)="onNoClick()">Anuluj</button>
	@if (payments.length !== 0) {
		<button type="button" mat-raised-button color="primary" (click)="save()">Zapisz</button>
	}
</mat-dialog-actions>
